import Vue from 'vue'
import Router from 'vue-router'
// teacher
import Tasks from '../views/teacher/tasks.vue'
import Correct from '../views/teacher/correct.vue'
import User from '../views/teacher/user.vue'
import Ocr from '../views/teacher/ocr.vue'
import MyTasks from '../views/teacher/myTasks.vue'
import TaskReview from '../views/teacher/taskReview.vue'
import OcrReview from '../views/teacher/ocrReview.vue'

// Login
import Login from '../views/login/login.vue'
// import Register from '../views/login/register.vue'


// student
import StudentIndex from '../views/student/index.vue'
import Refer from '../views/student/refer.vue'
import ArticalList from '../views/student/articalList.vue'

import StudentShoppingCar from '../views/student/myShoppingCar.vue'
import StudentUser from '../views/student/user.vue'
import Combo from '../views/student/combo.vue'
import VB from '../views/teacher/vb.vue'

Vue.use(Router)

export default new Router({
    mode:'history',
    routes: [
        //---login路由---//////////////////////////////////////////////////////////
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                title: '登录页面'
            }
        },
        // 登录页面
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: '登录页面'
            }
        },
        // 注册页面
        // {
        //     path: '/register',
        //     name: 'register',
        //     component: Register,
        //     meta: {
        //         title: '注册页面'
        //     }
        // },
        //---teacher路由---////////////////////////////////////////////////////////
        // 领取任务页面
        {
            path:'/tasks',
            name:'tasks',
            component:Tasks,
            meta:{
                title:'任务领取'
            }
        },

        // 我的任务页面
        {
            path:'/myTasks',
            name:'myTasks',
            component:MyTasks,
            meta:{
                title:'我的任务'
            }
        },
        // 作文批改页面
        {
            path:'/correct',
            name:'correct',
            component:Correct,
            meta:{
                title:'作文批改'
            }
        },


        //作文批改结果审核页面
        {
            path:'/taskReview',
            name:'taskReview',
            component:TaskReview,
            meta:{
                title:'作文批改审核'
            }
        },

        //ocr识别页面
        {
            path: '/ocr',
            name: 'ocr',
            component: Ocr,
            meta:{
                title:'ocr识别'
            }
        },

        // ocr识别结果审核页面
        {
            path: '/ocrReview',
            name: 'ocrReview',
            component: OcrReview,
            meta:{
                title:'识别结果审核'
            }
        },

        // 用户页面
        {
        path:'/user',
        name:'user',
        component:User,
        meta:{
            title:'用户中心'
        }
        },
    
        //---student路由---//////////////////////////////////////////////////////////
        // 学生端主页面
        {
            path:'/studentIndex',
            name:'studentIndex',
            component:StudentIndex
        },
        // 作文提交页面
        {
            path:'/refer',
            name:'refer',
            component:Refer
        },
        // 历史详情页面--需调整
        {
            path:'/articalList',
            name:'articalList',
            component:ArticalList
        },
        // 用户页面
        {
            path:'/studentUser',
            name:'studentUser',
            component:StudentUser
        },
        // 购物车页面
        {
            path:'/studentShoppingCar',
            name:'studentShoppingCar',
            component:StudentShoppingCar
        },
        // 我的套餐页面
        {
            path:'/combo',
            name:'combo',
            component:Combo
        }, 
        // 模拟页面
        {
            path:'/vb',
            name:'vb',
            component:VB
        }, 
    ]
})
